export default "__VITE_ASSET__BoqiGy8S__"